/**
 * Decide which Deep Dive view to render on a research article.
 *
 * Pure so the branching is unit-testable (the live logic lives in Article.js).
 *
 * Returns one of:
 *   'summary' — not on the analysis tab, or article has no deep-dive at all
 *   'locked'  — non-member: show the upsell/locked preview
 *   'limited' — member, but pdf_insights was withheld (B1 per-account cap) →
 *               graceful "limit reached" message instead of a blank tab
 *   'content' — member with content present: full ArticlePdfView
 */
export function selectDeepDiveView({ viewMode, hasPdfInsights, hasAccess, pdfInsightsPresent }) {
  if (viewMode !== 'analysis' || !hasPdfInsights) return 'summary';
  if (!hasAccess) return 'locked';
  return pdfInsightsPresent ? 'content' : 'limited';
}
